import React from 'react';
import { BarChart } from '../components';

class CardActivity extends React.Component{

        constructor(props) {
        super(props);
    
        this.state = {
            dataBar2: {
              "labels": [
                "S",
                "M",
                "T",
                "W",
                "T",
                "F",
                "S"
              ],
              "datasets": [
                {
                "label": "Dip",
                "data": [
                    489,
                    245,
                    300,
                    203,
                    339,
                    102,
                    234
                  ]
                },
                {
                "label": "Dap",
                "data": [
                    209,
                    245,
                    283,
                    403,
                    589,
                    692,
                    580
                  ]
                },
                {
                "label": "Dup",
                "data": [
                    289,
                    435,
                    323,
                    190,
                    289,
                    103,
                    200
                  ]
                },
                {
                "label": "Dop",
                "data": [
                    139,
                    415,
                    593,
                    378,
                    209,
                    432,
                    374
                  ]
                }
              ]
            }
        };
    }

    render(){
        return (
            <div className="card h-100 shadow-sm">
                <div className="card-body p-2">
                    <div className="row no-gutters">
                        <div className="col-xl-12 col-lg-6 py-3">
                            <div className="card border-0 h-100">
                                <div className="card-body p-1 text-center">
                                    <div className="text-uppercase mt-1"><i className="lnr lnr-rocket"></i> Activity</div>
                                    <div>
                                        <BarChart />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-12 col-lg-6 py-3">
                            <div className="card border-0 h-100">
                                <div className="card-body p-1 text-center">
                                    <div className="text-uppercase mt-1"><i className="lnr lnr-leaf"></i> Nodes</div>
                                    <div>
                                        <BarChart data={this.state.dataBar2} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default CardActivity;